import { render, staticRenderFns } from "./ui-edit-auto-modal.vue?vue&type=template&id=4353500d&"
import script from "./ui-edit-auto-modal.vue?vue&type=script&lang=js&"
export * from "./ui-edit-auto-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports